import { render, staticRenderFns } from "./CorrespondenceQuestion.vue?vue&type=template&id=313423ca&scoped=true"
import script from "./CorrespondenceQuestion.vue?vue&type=script&lang=ts"
export * from "./CorrespondenceQuestion.vue?vue&type=script&lang=ts"
import style0 from "./CorrespondenceQuestion.vue?vue&type=style&index=0&id=313423ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313423ca",
  null
  
)

export default component.exports